export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4000f203c2a3af41680359b873953a495299c4bc1b&name=revalidateCommunity!'